import { render, staticRenderFns } from "./AmazonTransparencyIcon.vue?vue&type=template&id=b863a436"
import script from "./AmazonTransparencyIcon.vue?vue&type=script&lang=js"
export * from "./AmazonTransparencyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports